module.exports = __webpack_public_path__ + "static/pitch_nights_mobile_header-7f80fc087b4b71ebe6a36d7965c512c1.png";